import { TopHat } from "@callcenter/design-system"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { t } from "i18next"
import { useUnit } from "effector-react"
import { $whiteLabel } from "@callcenter/white-label"
import { IS_PWA } from "@callcenter/shared-constants"

import { checkBrowserSupport } from "./helpers"

import styles from "./browser-support-warning.module.pcss"

const LowVersionAlert = () => <span>{t("component_commonKeys_browserWarning_outOfDate")}</span>

const NotSupportedAlert = () => {
  const { brandName } = useUnit($whiteLabel.$whiteLabelSettings)

  return <span>{brandName} works best in Google Chrome. Your browser might not support all features as expected.</span>
}

export const BrowserSupportWarning = () => {
  const browserStatus = useMemo(() => checkBrowserSupport(), [])
  const [isVisible, setIsVisible] = useState(true)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const timer = setTimeout(() => {
      if (containerRef.current) {
        containerRef.current.style.maxHeight = "100px"
      }
    }, 1000)

    return () => clearTimeout(timer)
  }, [])

  const handleClose = useCallback(() => {
    if (!containerRef.current) {
      return
    }

    containerRef.current.style.maxHeight = "0"

    setTimeout(() => {
      setIsVisible(false)
    }, 500)
  }, [])

  if (!browserStatus || !isVisible || IS_PWA) {
    return null
  }

  return (
    <div id="soft-blocker" className={styles.softBlockerContainer} ref={containerRef}>
      <TopHat onClose={handleClose} type="info">
        {browserStatus === "not_supported" && <NotSupportedAlert />}
        {browserStatus === "browser_soft_blocked" && <LowVersionAlert />}
      </TopHat>
    </div>
  )
}
